import axiosInstance from "./axiosSingleton";

export default function getUserMe_v2() {
  const url = `/v2/User/Me`;
  const axios = axiosInstance();
  return axios
    .get(url)
    .then((response) => response.data)
    .then((data) => JSON.stringify(data))
    .catch((error) => {
      console.error("Error fetching user data:", error);
      throw error;
    });
}
